import { Image } from 'cms-types'

import { Media } from '../types'

export default function isPayloadImage(src?: Media | null): src is Image {
  return src != null && 'sizes' in src
}
